import {Button, type ButtonProps} from '@mui/material';
import PublishIcon from '@mui/icons-material/Publish';
import {useTranslation} from 'react-i18next';

interface UploadButtonProps {
  onFileSelection?: (file: File) => void;
}

export const UploadButton = (props: ButtonProps & UploadButtonProps) => {
  const {t} = useTranslation('common');

  const {children, onFileSelection, ...originalProps} = props;
  const buttonProps: ButtonProps & {component: React.ElementType} = {
    variant: 'contained',
    component: 'label',
    endIcon: <PublishIcon />,
    ...originalProps,
  };

  return (
    <Button {...buttonProps}>
      {children ?? t('upload')}
      <input
        type="file"
        onChange={({target: {files}}) => {
          files && onFileSelection && onFileSelection(files[0]);
        }}
        hidden
        multiple
      />
    </Button>
  );
};
